export const PartneredDoctornavBarData = [
  {
    name: "List of Doctors for Online Consultation",
    navigatePath: "/partnered-doctor-online",
  },
  {
    name: "List of Doctors for In-Clinic Appointment",
    navigatePath: "/partnered-doctor-inclinic",
  },
  {
    name: "List of Doctors for Online and In-Clinic Appointment",
    navigatePath: "/partnered-doctor-both",
  },
];
